<template>
  <v-dialog v-model="localDialogFilter" :width="width" scroll-strategy="none">
    <v-card :retain-focus="false" min-width="700px" max-width="900px" max-height="600px" class="pa-4 py-2"
      style="background-color: white; border-radius: 12px; overflow-y: auto">
      <h1>{{ $t("ColumnFilter.searchBy", { itm: $t("products.title") }) }}</h1>

      <div class="row">
        <!-- Nom du produit -->
        <div class="col-4 justify-content-start">
          <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{
            $t("products.name")
            }}</v-card-title>
          <v-text-field v-model="localFilterParams.productName" id="productName" name="productName" maxlength="50"
            hide-details persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('products.name') })"
            variant="outlined" class="mt-n4"></v-text-field>
        </div>

        <!-- Catégorie avec sous-catégories -->
        <div class="col-4 justify-content-start">
          <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{
            $t("products.category")
            }}</v-card-title>
          <v-select v-model="localFilterParams.category" :items="categories" variant="outlined" hide-details
            persistent-placeholder :placeholder="$t('placeholder.select', { itm: $t('products.category') })"
            class="mt-n4" key="" item-title="name" item-value="id"></v-select>
        </div>

        <!-- Statut (Actif/Inactif) -->
        <div class="col-4 justify-content-start">
          <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{
            $t("products.status")
            }}</v-card-title>
          <v-select v-model="localFilterParams.status" :items="statusOptions" variant="outlined" hide-details
            persistent-placeholder :placeholder="$t('placeholder.select', { itm: $t('products.status') })"
            class="mt-n4"></v-select>
        </div>

        <!-- Disponibilité (En stock/Épuisé) -->
        <div class="col-4 justify-content-start">
          <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{
            $t("products.availability")
            }}</v-card-title>
          <v-select v-model="localFilterParams.availability" :items="availabilityOptions" variant="outlined"
            hide-details persistent-placeholder
            :placeholder="$t('placeholder.select', { itm: $t('products.availability') })" class="mt-n4"></v-select>
        </div>

        <!-- Référence (SKU) -->
        <div class="col-4 justify-content-start">
          <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{
            $t("products.sku")
            }}</v-card-title>
          <v-text-field v-model="localFilterParams.sku" id="sku" name="sku" maxlength="50" hide-details
            persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('products.sku') })"
            variant="outlined" class="mt-n4"></v-text-field>
        </div>

        <!-- Date de création (plage de dates) -->
        <div class="col-4 justify-content-start">
          <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{
            $t("products.creationDate")
            }}</v-card-title>
          <dateField v-model="localFilterParams.creationDate" :min-date="new Date('2000-01-01')" :max-date="new Date()"
            class="mt-n4" placeholder="Select date range" />
        </div>

        <!-- Intervalle de prix avec v-range-slider et champs de saisie -->
        <div class="col-12 justify-content-start">
          <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{
            $t("products.priceRange")
            }}</v-card-title>

          <!-- Slider pour l'intervalle de prix -->
          <v-range-slider v-model="localFilterParams.priceRange" :min="0" :max="localFilterParams.priceRange[1]"
            :step="10" hide-details persistent-placeholder class="flex-grow-1 price-slider mt-n4 mb-0" ticks="always"
            tick-size="2" color="#0d0849">
          </v-range-slider>

          <!-- Champs de prix alignés aux extrémités -->
          <div class="d-flex justify-content-between align-items-center mt-n3">
            <v-text-field v-model.number="localFilterParams.priceRange[0]" :min="0"
              :max="localFilterParams.priceRange[1]" type="number" hide-details class="small-price-field mx-3"
              @input="updateSliderMin" />

            <v-text-field v-model.number="localFilterParams.priceRange[1]" :min="localFilterParams.priceRange[0]"
              :max="localFilterParams.priceRange[1]" type="number" hide-details class="small-price-field mx-2"
              @input="updateSliderMax" />
          </div>
        </div>
      </div>
      <br />

      <!-- Boutons de confirmation -->
      <div class="d-flex justify-content-center align-items-center">
        <card-actions :yes="applyFilter" v-model="dialogfilter" :noFun="closeFilterDialog" width="100px"
          :yesTitle="$t('ColumnFilter.search')">
          <template v-slot:centerButton>
            <genericBtnComponent width="100px" :ClickFun="clearFilter" :Title="$t('invoices.clearBtn')" />
          </template>
        </card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import { getAllCategories } from "@/api/index";
import dateField from "@/genericComponent/date-field.vue";
import cardActions from "@/genericComponent/cardActions.vue";


export default {
  components: {
    genericBtnComponent,
    dateField,
    cardActions,
  },
  props: {
    dialogFilter: Boolean, // Contrôle si le dialogue est ouvert ou fermé
    filterParams: Object, // Paramètres de filtre passés depuis le parent
    categoryOptions: Array,
    statusOptions: Array,
    availabilityOptions: Array,
  },
  data() {
    return {
      categories: [],
      width: 950,
      height: 620,
      localDialogFilter: this.dialogFilter,
      localFilterParams: { ...this.filterParams },
    };
  },
  created() {
    this.loadCategories();
  },
  watch: {
    dialogFilter(val) {
      this.localDialogFilter = val;
    },
    localDialogFilter(val) {
      this.$emit("update:dialogFilter", val);
    },
    filterParams(val) {
      this.localFilterParams = { ...val };
    },
  },
  methods: {
    applyFilter() {
      const params = {
        pageNumber: 1,
        pageSize: 10,
        sortBy: null,
        sortDescending: false,
        SearchNom: this.localFilterParams.productName,
        categoryId: this.localFilterParams.category,
        isActive:
          this.localFilterParams.status === "Activated"
            ? true
            : this.localFilterParams.status === "Deactivated"
              ? false
              : null,
        availability:
          this.localFilterParams.availability === "En stock"
            ? true
            : this.localFilterParams.availability === "Épuisé"
              ? false
              : null,
        creationDate: this.localFilterParams.creationDate
          ? this.localFilterParams.creationDate
          : null,
        minPrice: this.localFilterParams.priceRange[0],
        maxPrice: this.localFilterParams.priceRange[1],
      };
      this.$emit("apply-filter", params);
      this.closeFilterDialog();
    },
    closeFilterDialog() {
      this.$emit("close-filter");
      this.localDialogFilter = false;
    },

    clearFilter() {
      this.$emit("clear");
      this.localFilterParams = {
        productName: "",
        category: null,
        status: null,
        availability: null,
        sku: "",
        creationDate: [],
        priceRange: [0, this.localFilterParams.priceRange[1]],
      };
    },
    loadCategories() {
      getAllCategories().then((response) => {
        this.categories = response.data.map((categoy) => ({
          id: categoy.categoryId,
          name: categoy.name,
        }));
      });
    },

  },
};
</script>

<style scoped>
h1 {
  font-family: inter;
  font-size: 18px;
  line-height: 29px;
  font-weight: 600;
  color: #0d0849;
  text-align: center;
}

.custom-card-title {
  font-size: 16px;
  color: #5b6d8e;
}

/* Styles personnalisés pour le slider */
.price-slider {
  height: 70px;
  /* Augmenter la taille du slider */
  --v-range-slider-thumb-size: 20px;
  /* Taille des poignées du slider */
  --v-range-slider-track-height: 20px;
  /* Hauteur de la piste */
}

/* Réduction de la taille des champs de prix */
.small-price-field {
  width: 100px;
  /* Réduire la largeur du champ de prix */
}

.v-card {
  overflow-y: auto;
  /* Ensure scrollable if content overflows */
}

.mt-n4 {
  margin-top: -10px;
}
</style>
